import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { DisbursementSalaryPayments } from "./DisbursementScreen/SalaryPayments";
import { DisbursementLoanPayments } from "./DisbursementScreen/LoanPayments";
import { DisbursementAdvancePayments } from "./DisbursementScreen/AdvancePayments";
import { DisbursementBankFileExport } from "./DisbursementScreen/BankFileExport";
import { DisbursementPaymentConfirmation } from "./DisbursementScreen/PaymentConfirmation";
import { DisbursementFailedPendingPayments } from "./DisbursementScreen/FailedPendingPayments";
import { DisbursementPaymentHistory } from "./DisbursementScreen/PaymentHistory";

// Payroll > Disbursement is a sidebar flyout (see routes.js). Each item has
// its own URL under /admin/payroll/disbursement/<item>, matching the
// DisbursementScreen sub-folders. Every item is a "not implemented yet"
// placeholder for now.
export const DISBURSEMENT_BASE_PATH = "/admin/payroll/disbursement";

const DISBURSEMENT_SCREENS = {
  "salary-payments": DisbursementSalaryPayments,
  "loan-payments": DisbursementLoanPayments,
  "advance-payments": DisbursementAdvancePayments,
  "bank-file-export": DisbursementBankFileExport,
  "payment-confirmation": DisbursementPaymentConfirmation,
  "failed-pending-payments": DisbursementFailedPendingPayments,
  "payment-history": DisbursementPaymentHistory,
};

export const Disbursement = () => {
  const { pathname } = useLocation();
  let path = pathname;
  while (path.endsWith("/")) path = path.slice(0, -1);
  const segment = path.startsWith(`${DISBURSEMENT_BASE_PATH}/`)
    ? path.slice(DISBURSEMENT_BASE_PATH.length + 1).split("/")[0].toLowerCase()
    : "";
  const Screen = DISBURSEMENT_SCREENS[segment];

  if (!Screen) {
    return <Redirect to={`${DISBURSEMENT_BASE_PATH}/salary-payments`} />;
  }
  return <Screen />;
};
